module.exports = __webpack_public_path__ + "static/media/regiao_sudeste.959aa68a.svg";